export function filterHTMLTag(content: string) {
  return content
    .replace(/<[^>]*>?/gm, '')
    .replace(/[\s\n\r\t]+/gm, ' ')
    .trim();
}
